export const getCoverImage = (images) => {
  if (images) {
    let idx = images.findIndex(file => {
      return file.cover == true
    })
    if (idx > -1) return images[idx].url
  }
  return ""
}

export const getCoverThumbnail = (images) => {
  if (images) {
    let idx = images.findIndex(file => {
      return file.cover == true
    })
    if (idx > -1) return images[idx].thumb
  }
  return ""
}



// WEBPACK FOOTER //
// ./src/listings/images/imageService.js